import dynamic from 'next/dynamic';
const EventSelectedCategories = dynamic(() => import('./EventSelectedCategories'));

export default EventSelectedCategories;
